export default __webpack_public_path__ + "static/media/looker.280491cd.svg";